import { useMemo } from 'react';

import type { ICellRendererParams } from '@mint-lib/ag-grid/community';
import type { useChannels } from '@mint-lib/hooks';
import { Activity } from '@mint-lib/icons';
import { TruncateText } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';
import { MediaPlan } from '@mint-sdk/api-media-plan';

import { ChannelIcon } from '@myn/mui';

import { MediaRowNameColumn } from './MediaRowNameColumn.jsx';

export const NameColumnInnerRenderer = ({
  node,
  data,
  channels,
}: ICellRendererParams<MediaPlan.MediaData, string> & {
  channels: ReturnType<typeof useChannels>;
}) => {
  const icon = useMemo(() => {
    if (data?.levelType === 'activity') {
      return <Activity className="min-w-4 fill-icon-secondary" />;
    }

    if (data?.levelType === 'channel') {
      const channel = channels[data.name];

      return channel ? <ChannelIcon component={channel.icon} /> : null;
    }

    return null;
  }, [data, channels]);

  if (data?.levelType === 'media_row') {
    return <MediaRowNameColumn mediaData={data} />;
  }

  return (
    <div
      className={cn(
        'flex h-7 items-center gap-2',
        !data?.hasChildren && !node.isRowPinned() && 'pl-7',
      )}
    >
      {icon}
      <TruncateText>
        {data?.levelType === 'activity' ? (
          <h6 className="m-0 text-sm font-semibold">{data?.label}</h6>
        ) : (
          <p className="m-0 text-sm">{data?.label}</p>
        )}
      </TruncateText>
    </div>
  );
};
